"use client";

import Link from "next/link";
import { useQuery } from "@tanstack/react-query";
import { LayoutGrid } from "lucide-react";
import { browserCoreApi } from "@/lib/api";
import { discoverKeys } from "./query-keys";
import { Popover } from "@/components/popover";
import { categoryColor } from "./category-color";

/** The categories icon inside the search field: every main category as a coloured chip. */
export function BrowseCategoriesPopover() {
  const explore = useQuery({
    queryKey: discoverKeys.explore,
    queryFn: ({ signal }) => browserCoreApi.discover.explore(signal),
    staleTime: 5 * 60_000,
  });
  const categories = explore.data?.categories ?? [];

  return (
    <Popover
      align="start"
      className="w-[min(26rem,calc(100vw-2rem))]"
      trigger={({ toggle, open }) => (
        <button
          type="button"
          onClick={toggle}
          aria-label="مرور دسته‌بندی‌ها"
          aria-expanded={open}
          className="text-muted-foreground hover:text-foreground border-border/70 flex h-7 items-center border-s ps-3"
        >
          <LayoutGrid className="size-5" />
        </button>
      )}
    >
      {(close) => (
        <div className="space-y-3 p-4">
          <h2 className="text-sm font-bold">مرور همه</h2>
          {categories.length === 0 ? (
            <p className="text-muted-foreground py-6 text-center text-sm">
              {explore.isPending ? "در حال بارگذاری…" : "دسته‌بندی‌ای وجود ندارد"}
            </p>
          ) : (
            <ul className="grid max-h-[60vh] grid-cols-2 gap-2 overflow-y-auto">
              {categories.map((category) => (
                <li key={category.id}>
                  <Link
                    href={`/categories/${category.id}`}
                    onClick={close}
                    className="block truncate rounded-lg px-3 py-3 text-sm font-bold text-white"
                    style={{ backgroundColor: categoryColor(category) }}
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Popover>
  );
}
